"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _conductor = require("@virtuous/conductor");

var _context = require("../context");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @param {string} id A route id.
 * @returns {Object|null}
 */
function useRoute() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var _useContext = (0, _react.useContext)(_context.RouterContext),
      stack = _useContext.stack;

  if (!id) {
    return _objectSpread({}, stack[_conductor.router.routeIndex][1], {
      update: function update(state) {
        _conductor.router.update(stack[_conductor.router.routeIndex][1].id, state);
      }
    });
  }

  var match = stack.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        routeId = _ref2[0];

    return id === routeId;
  });

  if (!match) {
    return {};
  }

  return _objectSpread({}, match[1], {
    update: function update(state) {
      _conductor.router.update(match[1].id, state);
    }
  });
}

var _default = useRoute;
exports["default"] = _default;